module.exports = __webpack_public_path__ + "img/68.0789d6a8.png";